import http from "../../helpers/http";
import * as helpers from "../../helpers/api";

import {
    FETCH_CATEGORY_BLOGS_CONTENT,
    FETCH_CATEGORY_BLOGS_CONTENT_SUCCESS,
    FETCH_CATEGORY_BLOGS_CONTENT_FAILED
} from "./actionTypes";

export const fetchCategoryBlog = (slug) => (dispatch) => {
    dispatch({
        type: FETCH_CATEGORY_BLOGS_CONTENT,
        payload: null
    });
    http
        .get("category-blogs-page/" + slug)
        .then(({ data }) => {
            dispatch({
                type: FETCH_CATEGORY_BLOGS_CONTENT_SUCCESS,
                payload: data
            });
        })
        .catch((error) => {
            dispatch({
                type: FETCH_CATEGORY_BLOGS_CONTENT_FAILED,
                payload: error
            });
        });
};
